<template>
    <div>
        <v-autocomplete
            v-model="user"
            :items="userStore.users"
            item-value="id"
            item-text="fullName"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";
import {useUserStore} from "@/stores/Setting/User";

export default {
    name: "StrUserAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        disabled: Boolean,
        label: String,
        rules: Array,
        multiple: Boolean,
        validator: Boolean,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const userStore = useUserStore();

        const user = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/users`, {params: { validator: props.validator}}).then(response => {
                userStore.setUsers(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            user.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            userStore,
            loading,
            inputColor,
            backgroundColor,
            user,
            input,
        }
    }
}
</script>

<style scoped>

</style>